<template>
  <footer aria-labelledby="footer-heading">
    <h2 class="sr-only">Footer</h2>
    <div class="w-screen border-t bg-gray-50 dark:bg-gray-900 dark:border-none">
      <div class="px-4 pt-16 pb-8 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <logo-svg class="h-10" />

        <div class="mt-2 text-gray-900 dark:text-white md:w-1/2">Contextual learning to improve your retention, comprehension and recollection with personalized daily reviews.</div>
        <div class="items-center justify-between block mt-10 text-gray-900 sm:flex dark:text-white">
          <div class="block space-y-3 font-bold sm:space-x-5 sm:flex sm:space-y-0">
            <div>
              <router-link to="/auth">Daily Review</router-link>
            </div>
            <!-- <div>
              <router-link to="/auth">Sign Up</router-link>
            </div> -->
            <div>
              <a href="mailto:hello@wisery.io">Contact Us</a>
            </div>
            <div>
              <a href="https://twitter.com/wiseryHQ">Twitter</a>
            </div>
          </div>
          <div class="flex items-center justify-between mt-10 sm:space-x-5 sm:mt-5">
            <div>© Wisery 2021</div>
            <div>
              <router-link to="/tos" class="font-bold">Terms</router-link>
            </div>
            <div>
              <router-link to="/privacy" class="font-bold">Privacy</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import LogoSvg from './logos/LogoSvg.vue'
export default {
    components: {
        LogoSvg
    }
};
</script>